var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "themes-editor-nav-section overflow-y-scroll h-100" },
    [
      _setup.sectionData.helpText && _setup.alphaMode
        ? _c(_setup.HelpBox, { attrs: { id: _setup.helpBlockId } }, [
            _c("div", { staticClass: "mb-1 fw-bold" }, [
              _vm._v(_vm._s(_setup.sectionData.title)),
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_setup.sectionData.helpText) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _setup.sectionName === "content_types"
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center mb-2 pt-1" },
            [
              _c(_setup.ThemesEditorNavSearch),
              _vm._v(" "),
              _c(_setup.ThemesEditorAlphaSortBtn),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.sectionName === "content_types" &&
      !_setup.sortAlpha &&
      _setup.navSearch === ""
        ? [
            _vm._l(_setup.contentTypes, function (contentType) {
              return [
                _c(
                  "h6",
                  {
                    key: "header-" + contentType,
                    staticClass:
                      "mt-5 w-100 ps-2 pb-2 border-bottom text-secondary-emphasis",
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(contentType) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(
                  _setup.items.filter((o) => o.contentType === contentType),
                  function (item) {
                    return _c(_setup.ThemesEditorNavLink, {
                      key: item.id,
                      attrs: {
                        "active-editor-key": _setup.activeEditorKey,
                        item: item,
                      },
                    })
                  }
                ),
              ]
            }),
          ]
        : _vm._l(_setup.filteredItems, function (item) {
            return _c(_setup.ThemesEditorNavLink, {
              key: item.id,
              attrs: {
                "active-editor-key": _setup.activeEditorKey,
                item: item,
              },
            })
          }),
      _vm._v(" "),
      _c("div", { staticClass: "my-5 py-5" }, [_vm._v(" ")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }